<div class=" grid-container">
	<div class="item item-1 search-bar mat-elevation-z2">
		<input class="search-input" placeholder="Pesquisar" [(ngModel)]="strPesquisa" (keyup.enter)="pesquisar()" #searchInput>
		<button class="search-button" mat-raised-button (click)="pesquisar()"><mat-icon
				class="search-icon">search</mat-icon></button>
	</div>
	@if (utilizaPesquisaAvancada) {
	<div class="icone-filtro">
		<mat-icon
			[matBadge]="qtdFiltros"
			[matBadgeHidden]="!qtdFiltros"
			matBadgeColor="warn"
			matBadgePosition="above after"
			matBadgeSize="small"
			(click)="abrirDialog()"
			(aplicarFiltrosEmitter)="aplicarFiltrosInterno($event)">directions_car</mat-icon>
			<label>Veículos</label>
	</div>
	}
</div>
